var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowUpCircleLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.33301C11.6807 1.33301 14.6673 4.31967 14.6673 7.99967C14.6673 11.6797 11.6807 14.6663 8.00065 14.6663C4.32065 14.6663 1.33398 11.6797 1.33398 7.99967C1.33398 4.31967 4.32065 1.33301 8.00065 1.33301ZM8.00065 13.333C10.9473 13.333 13.334 10.9463 13.334 7.99967C13.334 5.05301 10.9473 2.66634 8.00065 2.66634C5.05398 2.66634 2.66732 5.05301 2.66732 7.99967C2.66732 10.9463 5.05398 13.333 8.00065 13.333ZM8.66732 7.99967V10.6663H7.33398V7.99967H5.33398L8.00065 5.33301L10.6673 7.99967H8.66732Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUpCircleLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-up-circle-line.97fc8371.svg";
export { ForwardRef as ReactComponent };